// Mega Menu Hover script Start
document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
  let activeMenuItem = null; 
  menuItems.forEach((item, index) => {
    const detailsElement = item.querySelector('details');
    if (!detailsElement) {
      return;
    }
    item.addEventListener('mouseenter', () => {
      if (activeMenuItem && activeMenuItem !== item) {
        const previousDetailsElement = activeMenuItem.querySelector('details');
        if (previousDetailsElement) previousDetailsElement.removeAttribute('open');
      }
      detailsElement.setAttribute('open', true);
      activeMenuItem = item; 
    });
 
    item.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!item.matches(':hover')) {
          detailsElement.removeAttribute('open');
          if (activeMenuItem === item) activeMenuItem = null; 
        } 
      }, 500); // Adjust delay as needed
    });
  });
});
 
// Mega Menu Hover script End

// footer script

var coll = document.getElementsByClassName("collapsible");
var i;
 
for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}



//*** Css overflow slider ***//
var sliders = document.querySelectorAll('.scrolling_main_wrp');
var isDown = false;
var startX;
var scrollLeft;

sliders.forEach(slider => {
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
    enableLinks(); // Re-enable links on mouse leave
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
    enableLinks(); // Re-enable links on mouse up
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1; // scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    disableLinks(); // Disable links when scrolling horizontally
  });
});

function disableLinks() {
  var links = document.querySelectorAll('.scrolling_main_wrp .scrolling_item');
  links.forEach(link => {
    link.style.pointerEvents = 'none'; // Disable link clicks
  });
}

function enableLinks() {
  var links = document.querySelectorAll('.scrolling_main_wrp .scrolling_item');
  links.forEach(link => {
    link.style.pointerEvents = 'auto'; // Re-enable link clicks
  });
}
